export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const SECONDS_PER_DAY =
    HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE;
export const MILLISECONDS_PER_DAY =
    HOURS_PER_DAY *
    MINUTES_PER_HOUR *
    SECONDS_PER_MINUTE *
    MILLISECONDS_PER_SECOND;
export const MILLISECONDS_PER_MINUTE =
    MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE;
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * MINUTES_PER_HOUR;

interface RecentTimeStamp {
    time: number | undefined;
    label: string;
}

export const DEFAULT_TIME: RecentTimeStamp = {
    time: undefined,
    label: "",
};

function dateStringIsValid(dateString: string): boolean {
    if (!dateString || typeof dateString !== "string") {
        return false;
    }

    return !Number.isNaN(Date.parse(dateString));
}

const getRelativeTime = (
    publishedAt: string,
    updatedAt?: string
): RecentTimeStamp => {
    if (!dateStringIsValid(publishedAt)) {
        return { ...DEFAULT_TIME };
    }

    const publishedDate = new Date(publishedAt);
    const updatedDate =
        updatedAt && dateStringIsValid(updatedAt) ? new Date(updatedAt) : null;
    const updated =
        updatedDate && updatedDate.getTime() > publishedDate.getTime();
    const date = updated ? updatedDate : publishedDate;
    const now = Date.now();
    const elapsed = now - date.getTime();

    if (elapsed < MILLISECONDS_PER_MINUTE) {
        return { time: 1, label: "min" };
    }

    if (elapsed < MILLISECONDS_PER_HOUR) {
        return {
            time: Math.round(elapsed / MILLISECONDS_PER_MINUTE),
            label: "min",
        };
    }

    return {
        time: Math.round(elapsed / MILLISECONDS_PER_HOUR),
        label: "hr",
    };
};

export default getRelativeTime;
